module.exports = {
	"en":{
		"userData.tipsText13":"Male",
		"userInfo.formLabel[8]":"Membership Status",
		"userData.tipsText14":"Date of Birth",
		"userData.tipsText15":"Area of residence",
		"userInfo.datorErrText[5]":"Maximum 25 digits only",
		"userData.tipsText16":"Member Status",
		"forgetPassword.password":"Password",
		"register.rulesPassword":"Enter your password",
		"userData.tipsText17":"Activated",
		"userData.tipsText18":"(requested deletion)",
		"login.loginName":"Account",
		"userData.tipsText19":"Other information",
		"register.placeholderLoginName":"Enter mobile number",
		"login.err":"Login Failed",
		"register.placeholderLoginName2":"Enter email address",
		"register.loading":"Loading",
		"register.getCodeText":"Get code",
		"forgetPassword.doForgetPassword":"Confirm",
		"userData.tipsText20":"Delete account",
		"userData.tipsText21":"Save",
		"userData.tipsText22":"Icon updated",
		"userInfo.userImgButton":"Upload icon",
		"userData.tipsText23":"Error",
		"forgetPassword.placeholder3":"Enter new password",
		"userInfo.placeholder[0]":"Please enter your place of residence",
		"forgetPassword.placeholder4":"Enter verification code",
		"forgetPassword.placeholder2":"Enter email",
		"userInfo.formLabel[7]":"Place of residence",
		"userInfo.serveStatus":"Status",
		"userInfo.datorErrText[4]":"Special character are not allowed in your name",
		"register.tipsText9":"Privacy Policy",
		"register.placeholderPassword2":"Enter password again",
		"ui.placeholderPhone":"Enter mobile number",
		"register.tipsText8":"T & C",
		"register.tipsText7":"You can also activate other service",
		"register.tipsText6":"Activate other service of SUPer Card",
		"register.tipsText5":"I agree to receive direct marketing information of SUPer Card and {count}.",
		"register.tipsText4":"I agree to receive direct marketing information of SUPer Card and {count}.",
		"register.tabText":"Mobile Registration",
		"register.tipsText3":"Enter promotion code (optional)",
		"register.tipsText2":"Enter password again",
		"forgetPassword.placeholder5":"Updating",
		"register.tipsText1":"Set up password",
		"userInfo.success":"Done",
		"userServe.tipsText1":"Activate other service of SUPer Card",
		"userServe.tipsText2":"SUPer Card also provide various service and promotion offer",
		"register.success":"Successful Registration.",
		"userServe.tipsText3":"Agree to activate",
		"userServe.tipsText4":"Activated",
		"login.placeholderPassword":"Enter password",
		"userServe.tipsText5":"Preference for receiving marketing information",
		"userInfo.openServe":"Status of enabled service",
		"userServe.tipsText6":"Back",
		"forgetPassword.rulesPassword":"Enter your password",
		"ui.getCodeSuccess":"Sent",
		"userInfo.serveTips9":"Verification code",
		"userServe.tipsText7":"Please login to update your preference",
		"ui.86":"+86 China",
		"register.rulesCheckedItem":"Please select to agree with the above terms",
		"userInfo.serveTips8":"Please check the required fields",
		"userServe.tipsText8":"Unable to reset current service",
		"userInfo.serveTips7":"Upload photos",
		"userServe.tipsText9":"Deactivate the service and logout your account",
		"userInfo.open":"Open",
		"userInfo.serveTips6":"Link with third-party",
		"userInfo.serveTips5":"Email:",
		"userData.tipsText10":"Name",
		"userInfo.serveTips4":"Please contact by email if you want to deactivate your account",
		"userData.tipsText11":"Gender",
		"userInfo.serveTips3":"Deactivate the service and logout your account",
		"userData.tipsText12":"Female",
		"userInfo.serveTips2":"Activate the service",
		"userInfo.formLabel[6]":"Date of Birth",
		"register.loginName":"Account",
		"ui.placeholderCode":"Code",
		"login.loginButtonText":"Login",
		"userInfo.datorErrText[3]":"Special character are not allowed in your nick name",
		"userInfo.bind":"Link",
		"err.title":"Reminder",
		"register.disableAccount":"Deactivate or delete account",
		"openServiceLogin.tipsText2":"You can also activate other service platforms.",
		"openServiceLogin.tipsText1":"Activate {count} service",
		"deleteAccount.tipsText4":"If there are still pending orders in the account, we will process the account deletion request after all orders have been completed.",
		"deleteAccount.tipsText3":"All data in your account, including personal information, membership, cumulative spending, coupon, e-voucher, points or other rewards, will be deleted.",
		"deleteAccount.tipsText2":"Your account will be automatically logged out and unable to login again once deleted",
		"deleteAccount.tipsText1":"Reminder: Account Deletion",
		"register.lastStep":"Previous",
		"deleteAccount.tipsText8":"I have read and understood the above instructions.",
		"deleteAccount.tipsText7":"We will process your application within 7-14 working days",
		"deleteAccount.tipsText6":"Your account will be automatically logged out and unable to login again once deleted",
		"deleteAccount.tipsText5":"If you apply to delete your account, you cannot apply refund or exchange of your orders",
		"deleteAccount.tipsText9":"Confirm the request to delete the account",
		"register.nextStop":"Next",
		"userInfo.formLabel[5]":"Email Address",
		"userInfo.datorErrText[2]":"Maximum 12 digits only",
		"login.tipsText12":"Binding failed",
		"ui.tipsTitle":"Reminder",
		"login.tipsText11":"Binding successful",
		"login.tipsText10":"Please sign in or login your account",
		"login.tipsText16":"Sign-in failed",
		"userInfo.openButton":"Activate now",
		"login.tipsText15":"Successfully logged on",
		"login.tipsText14":"Please enter correct mobile number",
		"forgetPassword.subTitle":"My Book One",
		"login.tipsText13":"Please read and agree below service",
		"login.success":"Successfully logged on",
		"register.placeholder3":"Enter password again",
		"register.placeholder2":"Enter password",
		"viewQRCode.closeButton":"Close",
		"register.placeholder5":"Fill in the registration information",
		"register.placeholderPassword":"Set up password",
		"register.placeholder4":"The password should comprise of letters & numbers",
		"login.submit":"Login",
		"login.password":"Password",
		"userInfo.formLabel[4]":"Mobile Number",
		"userInfo.serveEmail":"Direct Marketing",
		"forgetPassword.rulesCode":"Enter verification code",
		"forgetPassword.placeholder":"Enter mobile number",
		"forgetPassword.rulesOldPassword":"Enter your password",
		"ui.placeholderPhone3":"Please enter correct mobile number",
		"ui.placeholderPhone4":"Enter mobile number",
		"ui.placeholderPhone2":"Please enter correct mobile number",
		"err.appErrText":"Error, please contact us.",
		"login.title":"Single Sign-On",
		"forgetPassword.title":"Reset password",
		"userInfo.formLabel[3]":"Gender",
		"userInfo.phone":"Mobile Number",
		"userInfo.datorErrText[7]":"Only Chinese, English, spaces, and numbers are allowed to be entered.",
		"userServe.tipsText10":"Deactivate the service",
		"userServe.tipsText11":"Activate the service",
		"nav.text8":"Personal Information",
		"nav.text9":"Successful Registration",
		"userInfo.email":"Email",
		"userInfo.formLabel[2]":"Reset password",
		"userInfo.rulesName":"Enter your mobile number",
		"userInfo.close":"Close",
		"ui.placeholderPassword4":"The password should comprise of letters & numbers",
		"userServe.tipsText12":"Updated",
		"register.placeholdeSrubPromoCode":"Enter promotion code (optional)",
		"userServe.tipsText13":"Service not activated",
		"userInfo.datorErrText[6]":"Only Chinese, English, and spaces are allowed to be entered",
		"ui.placeholderPassword3":"The two entries of password do not match",
		"ui.placeholderPassword2":"Enter password",
		"register.rulesCode":"Enter verification code",
		"userInfo.operationSuccess":"Done",
		"userInfo.formLabel[1]":"Nick Name",
		"login.placeholderLogin2":"Enter email & password",
		"userInfo.closeServe":"Disabled service",
		"login.placeholderLogin":"Enter mobile number & password",
		"nav.text2":"Forgot password",
		"forgetPassword.placeholderPassword":"Enter password",
		"nav.text3":"Registration",
		"register.privacyText":"Privacy Policy",
		"nav.text1":"Member login",
		"nav.text6":"Link with mobile number",
		"nav.text7":"A/C Binding",
		"userInfo.stopButton2":"Apply for deactivation",
		"nav.text4":"Terms & Conditions",
		"nav.text5":"Link with email",
		"err.tipsText1":"Back to Member page",
		"register.loginText":"Login current account",
		"err.tipsText5":"activate & login",
		"userInfo.stopButton":"Deactivate or delete account",
		"err.tipsText4":"Reminder",
		"err.tipsText3":"Please activate to enjoy the service",
		"forgetPassword.submit":"Confirm",
		"err.tipsText2":"Loading",
		"forgetPassword.placeholderLoginName2":"Enter email address",
		"userInfo.formLabel[0]":"Name",
		"forgetPassword.placeholderLoginName":"Enter mobile number",
		"forgetPassword.tablName1":"Mobile",
		"forgetPassword.tablName2":"Email",
		"userInfo.alter":"Amend",
		"register.password":"Password",
		"registerResult.tipsText4":"Service platform activated",
		"registerResult.tipsText3":"We will try our best to provide an excellent cultural & reading experience.",
		"register.forgetPassword":"Reset password",
		"register.regSuccess":"Experience now",
		"login.subTitle":"My BookOne",
		"forgetPassword.getCodeText2":"{count} second",
		"userData.tipsText79":"Application submitted",
		"forgetPassword.placeholderOldPassword":"Enter old password",
		"register.tablName1":"Mobile Registration",
		"register.tablName2":"Email Registration",
		"ui.placeholderEmail3":"Enter your correct email",
		"userInfo.serveTips":"Deactivate the service",
		"login.newUser":"Join",
		"userInfo.gender[1]":"Female",
		"register.getCodeText2":"{count} second",
		"ui.placeholderEmail2":"Enter Email",
		"userData.tipsText80":"Deactivation successful",
		"userData.tipsText81":"Unbind",
		"ui.886":"+886 Taiwan, China",
		"register.rules2":"I agree to receive direct marketing information of SUPer Card and {count}.",
		"forgetPassword.placeholderPassword2":"Enter password again",
		"register.rules3":"I agree to receive direct marketing information of SUPer Card.",
		"ui.placeholderEmail":"Enter email address",
		"register.merchant":"Joints Merchant",
		"login.placeholderLoginName":"Enter mobile number",
		"userData.tipsText68":"Disable",
		"register.tipsText18":"I have read and agreed to the Terms & Conditions,  Privacy Policy of \"SUPer Card.\" I also agree to activate the service of My Book One and accept its Terms & Conditions and Privacy Policy.",
		"register.tipsText17":"Our Business",
		"register.title":"Experience a cultural and literary lifestyle with SUPer Card",
		"userData.tipsText69":"Delete",
		"register.tipsText16":"Statement of Privacy Policy",
		"forgetPassword.textTips1":"Reset password",
		"register.tipsText15":"Terms & Conditions",
		"nav.text14":"Apply for account deletion",
		"register.tipsText14":"About SUPer Card",
		"nav.text13":"Member QR Code",
		"register.tipsText13":"Invalid promotion code",
		"nav.text12":"Membership",
		"register.tipsText12":"Close",
		"nav.text11":"Service Management",
		"register.tipsText11":"Direct Marketing",
		"forgetPassword.rulesName":"Enter your login name",
		"nav.text10":"Service",
		"register.termsText":"Terms & Conditions",
		"forgetPassword.placeholderCode":"Enter verification code",
		"ui.placeholderCode2":"Get code",
		"ui.placeholderCode3":"{count} second",
		"userInfo.gender[0]":"Male",
		"userData.tipsText70":"Get code",
		"register.tipsText10":"Activate",
		"userData.tipsText71":"Mobile",
		"userData.tipsText72":"Email",
		"userData.tipsText73":"Reason",
		"userData.tipsText74":"Please enter the reason",
		"userData.tipsText75":"Member services will be unavailable after deactivation",
		"login.rulesPassword":"Enter your password",
		"userData.tipsText76":"All data of your account will be irrecoverable once deleted",
		"userData.tipsText77":"Confirm the application to delete the membership",
		"userData.tipsText78":"Confirm the deactivation of membership",
		"userData.tipsText57":"Binding",
		"userData.tipsText58":"Disabled third-party binding service",
		"userData.tipsText59":"Loading",
		"login.tablName1":"Mobile",
		"login.tablName2":"Email",
		"register.submit":"Registration",
		"userInfo.formLabel[10]":"Member Number",
		"userInfo.placeholder[3]":"Unchangeable",
		"userInfo.datorErrText[1]":"Please enter at least 2 digits",
		"forgetPassword.placeholderNewPassword":"Enter new password",
		"register.placeholderSubPromoCode":"Enter promotion code",
		"login.forgetText":"Forgot password",
		"register.subTitle":"Welcome to register as a SUPer Card member  and activate {count} plaltform",
		"userData.tipsText60":"Confirm to unbind?",
		"login.loginButtonText2":"Loading",
		"userData.tipsText61":"Unbinding successful",
		"userData.tipsText62":"Select your gender",
		"userData.tipsText63":"Enter the date of birth",
		"register.save":"Save",
		"userData.tipsText64":"Cancel",
		"userData.tipsText65":"Place of residence.",
		"userData.tipsText66":"Enter residence",
		"userData.tipsText67":"Type",
		"register.placeholder":"Please select to agree with the above terms",
		"userData.tipsText46":"Confirm new password",
		"userData.tipsText47":"Enter new password",
		"userData.tipsText48":"Reset",
		"userData.tipsText49":"The password should comprise of letters & numbers",
		"register.nextStep":"Next",
		"userInfo.placeholder[4]":"Select date",
		"forgetPassword.loginName":"Account",
		"register.tabText2":"Email Registration",
		"userInfo.datorErrText[0]":"The name cannot contain numbers",
		"ui.placeholderPassword":"Enter password",
		"register.rulesName":"Enter your login name",
		"login.deleSuccess":"Deleted",
		"userInfo.serveRules2":"Privacy Policy",
		"userData.tipsText50":"Please enter two or more English letters and numbers",
		"userInfo.serveRules1":"T & C",
		"userData.tipsText51":"Maximum 12 digits only",
		"userInfo.serveRules4":"T & C",
		"userData.tipsText52":"Symbols are not allowed",
		"userInfo.serveRules3":"T & C",
		"userData.tipsText53":"The two entries of password do not match",
		"deleteAccount.tipsText12":"All data of your account will be irrecoverable once deleted",
		"userData.tipsText54":"The new password must not be the same as the old password",
		"userInfo.change":"Change",
		"deleteAccount.tipsText13":"Submitted",
		"userData.tipsText55":"Password changed",
		"deleteAccount.tipsText10":"Please read the instructions and click the box",
		"userData.tipsText56":"Click to unbind",
		"deleteAccount.tipsText11":"Reminder",
		"login.rulesName":"Enter your login name",
		"userData.tipsText35":"Verification code sent to the email address",
		"userData.tipsText36":"Invalid verification code",
		"userData.tipsText37":"The system will resend in 60 seconds",
		"userData.tipsText38":"Please enter correct mobile number",
		"userInfo.placeholder[1]":"Enter your Name",
		"register.placeholderCode":"Enter verification code",
		"userData.tipsText39":"Please enter correct mobile number with 8 digits",
		"forgetPassword.getCodeText":"Get code",
		"forgetPassword.placeholderNewPassword2":"Enter password again",
		"userData.tipsText40":"Please enter correct mobile number with 11 digits",
		"register.doRegister":"Registration",
		"userData.tipsText41":"Verification code sent",
		"userData.tipsText42":"Password",
		"userInfo.unvalidated":"Unverified",
		"userData.tipsText43":"Enter old password",
		"userData.tipsText44":"New password",
		"userData.tipsText45":"Enter new password",
		"login.tipsText5":"Signed in device",
		"userData.tipsText24":"Birthday can only be filled in once",
		"registerResult.tipsText2":"Congratulations! You have successfully completed the registration.",
		"login.tipsText4":"You account is linked with below device, please contact us.",
		"userData.tipsText25":"Cannot be empty",
		"userInfo.formLabel[9]":"Icon",
		"registerResult.tipsText1":"Registered",
		"login.tipsText3":"Your account is already logged in on below device, do you want to logout your account on below device?",
		"userData.tipsText26":"Enter your name",
		"userInfo.placeholder[2]":"Enter your Nick Name",
		"login.tipsText2":"Device Binding",
		"userData.tipsText27":"Please enter at least 2 digits",
		"login.tipsText9":"Loading with third-party",
		"userData.tipsText28":"Maximum 25 digits only",
		"login.placeholderLoginName2":"Enter email",
		"login.tipsText8":"Login in with {count}",
		"userData.tipsText29":"Only Chinese, English, and spaces are allowed to be entered",
		"login.tipsText7":"Login in with this device",
		"login.tipsText6":"Binding devices",
		"login.tipsText1":"Your account is already logged in on a different device",
		"login.otherType":"Other login method",
		"userData.tipsText7":"Reset password",
		"userData.tipsText6":"Mobile Number",
		"userData.tipsText9":"Login your account through third-party after binding",
		"forgetPassword.success":"Password changed",
		"userData.tipsText8":"Third-party Account",
		"ui.853":"+853 Macau SAR",
		"userData.tipsText1":"Member Number",
		"userData.tipsText30":"Updated",
		"userData.tipsText3":"Nick Name",
		"userData.tipsText31":"Enter your Nick Name",
		"userData.tipsText2":"Icon",
		"userData.tipsText32":"Enter 2-25 digits only",
		"userData.tipsText5":"Unverified",
		"userData.tipsText33":"Enter Email",
		"userInfo.title2":"Joint Service",
		"ui.852":"+852 Hong Kong SAR",
		"userData.tipsText4":"Email",
		"userData.tipsText34":"Confirm",
		"userInfo.title1":"Membership",
		"login.captchaText":"Please slide to verify",


		"form.confirmBtn": "Confirm",
		"form.cancelBtn": "Cancel",
	}
}